
import { Component, Vue, Watch } from 'vue-property-decorator'
import { userService } from '@/api/userService'
import PagedListBase, { PagedRequestDto } from '@/lib/view-base/paged-list-base'
import { UserByTypeDto,  CreateOrDeleteUserPurViewInput } from '@/api/service-proxies'
import Pagination from '@/components/Pagination/index.vue'
import { schoolService } from "@/api/settings/school";

class PageUserRequest extends PagedRequestDto {
  name!: string
  tenantId!: number
  phoneNumber!: string
  userType:number
}

@Component({
  name: 'UserPurView',
  components: {
    Pagination
  },
})
export default class extends PagedListBase<PageUserRequest, UserByTypeDto> {
  request = new PageUserRequest()
  isTableLoading = false
  tenants = []

  created() {
    this.getTenantData()
    this.getpage()
  }
  getTenantData() {
    schoolService.getUserSchools().then((result) => {
      this.tenants = result.items;
    });
  }
  changeTenant(id){
    this.request.tenantId  =id
  }

  getpage(): void {
    this.isTableLoading = true;
    userService
      .getUserByType(
        this.request.name,
        this.request.phoneNumber,
        this.request.tenantId,
        10,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then((result) => {
        this.list = result.items
        this.showPaging(result)
      })
      .finally(() => {
          this.isTableLoading = false;
      })
  }

  //开启或者关闭
  managerChange(row:UserByTypeDto){
    console.log(row.phoneNumber+"___" +row.isOpenVipManager)
    var input = new CreateOrDeleteUserPurViewInput();
    input.userId = row.id;
    input.isOpenVipManager = row.isOpenVipManager;
    input.tenantId = row.tenantId;
    userService.createOrDeleteUserPurView(input)
    .then((res)=>{
      this.$message.success(input.isOpenVipManager?"已开启":"已关闭");
    })
    .catch((e)=>{
      this.$message.error("修改失败");
    });
  }
}
